import Scroller from '@templates/Scroller/Scroller.js';
import Navigation from '@templates/Navigation/Main/Navigation.main.js';
import Form from '@modules/forms/Form.js';
import _debounce from 'lodash/debounce';
import AOS from 'aos';
import Header from "@templates/Header/Header";
import VideoPlayer from "@templates/Elements/VideoPlayer/VideoPlayer";
import Templates from "@templates/Templates/Sitelab/Templates";
import ButtonCopy from "@templates/Elements/Buttons/Button.copy";
import Menu from "@templates/Navigation/Menu/Menu";
import LayoutPlayground from "@templates/Layout/Flex/Layout.playground";
import Modules from "@modules/Modules";
import SVGInjector from "svg-injector";
import Popup from "@templates/Components/Popup/Popup";
import ContactMap from "@pages/patterns/Map/Map";
import Extender from "@templates/Components/Extender/Extender";
import Switcher from "@templates/Components/Switcher/Switcher";
import RentalPages from "@pages/Rent/RentalPages";
import Accordion from "@templates/Components/Accordion/Accordion";
import ScrollSectionWithMenu from "@templates/Templates/ScrollSectionWithMenu/ScrollSectionWithMenu";
import HeaderImage from "@pages/patterns/HeaderImage/HeaderImage";
// import Flayer from "@templates/Components/Flayer/Flayer";
// import Submenu from "@templates/Navigation/Submenu/Submenu";
// import Router from "@templates/App/Router";

const App = {
    debug: false,
    hasDirectory: false,

    init: function () {
        $(document).ready(function ($) {
            App.setProps();
            if (window.parent.editorGateway !== undefined) {
                $('body').addClass('sitelab');
                Modules.init();
            } else {
                // App.injectSVG();
                Scroller.init();
                App.start();
            }

            window.AOS = AOS;
        });

        this.el = $('[component="application"]');
        $(window).resize(_debounce(this.resize, 300))
    },

    start() {
        if (this.deviceIsIphone()) {
            $('body').attr('device', 'iphone');
            App.isIphone = true;
            $('[aos]').each((i, el) => {
                $(el).attr('data-aos', $(el).attr('aos'));
                $(el).removeAttr('aos');
            })
        }
        if (this.deviceIsMac()) {
            $('body').attr('device', 'mac');
            App.isMac = true;
        }
        Header.init();
        HeaderImage.init();
        VideoPlayer.init();
        Popup.init();
        Navigation.init();
        Form.init();
        Menu.init();
        // Submenu.init();
        Extender.init();
        Switcher.init();
        ScrollSectionWithMenu.init();

        setTimeout(() => {
            ContactMap.init();
        }, 100)

        //MODULES
        Modules.init();
        // Router.init();
        // Flayer.init();

        //SYSTEM - backend
        ButtonCopy.init();
        Templates.init();
        LayoutPlayground.init();
        RentalPages.init();
        Accordion.init();
        // ---------------------------//
        // Privatezone.init();
        // ShowPassword.init();

        this.bindScrollAnimation();
        setTimeout(function () {
            App.show();
        }, 1);
        // ParallaxAnimation.init();

    },

    setProps() {
        App.isLandscape = window.innerWidth > window.innerHeight;
        App.isPortrait = !App.isLandscape;
        App.isDesktop = window.innerWidth > 1000;
        App.isTablet = window.innerWidth < 1000 && window.innerWidth > 760;
        App.isMobile = window.innerWidth <= 760;
    },

    resize: function () {
        App.setProps();
        // Scroller.resize();
        Templates.resize();
        Menu.resize();
        Navigation.resize();
        ContactMap.resize();
        Modules.resize();
        HeaderImage.resize();

        setTimeout(function () {
            AOS.refresh();
        }, 500);
    },

    deviceIsIphone() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        } else {
            return null;
        }
    },

    deviceIsMac() {
        return /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    },

    injectSVG() {
        let svgs = $('img[src$=".svg"].inject');

		let options = {
            evalScripts: 'once',
            // pngFallback: 'assets/png',
            each: function (svg) {
                // Callback after each SVG is injected
                // console.log('SVG injected: ' + svg.getAttribute('id'));
            }
        };

        SVGInjector(svgs, options, function (totalSVGsInjected) {
            // Callback after all SVGs are injected
            // console.log('We injected ' + totalSVGsInjected + ' SVG(s)!');
        });
    },

    bindScrollAnimation() {
        AOS.init({
            // Global settings:
            disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
            startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
            initClassName: 'aos-init', // class applied after initialization
            animatedClassName: 'aos-animate', // class applied on animation
            useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
            disableMutationObserver: false, // disables automatic mutations' detections (advanced)
            debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
            throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

            // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
            offset: 100, // offset (in px) from the original trigger point
            delay: 0, // values from 0 to 3000, with step 50ms
            duration: 750, // values from 0 to 3000, with step 50ms
            easing: 'ease', // default easing for AOS animations
            once: false, // whether animation should happen only once - while scrolling down
            mirror: false, // whether elements should animate out while scrolling past them
            anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
        });
    },

    winLoaded: function () {
        return new Promise(function (resolve, reject) {
            $(window).load(resolve);
        });
    },

    show: function () {
        this.el.removeAttr('before-show').attr('show', '');
        $('[component]').removeAttr('before-show').attr('show', '');
        $('[page]').removeAttr('before-show').attr('show', '');

        $('[state="added"]').attr('state', 'show');

        /*TODO
            iný spôsob vymyslieť ako zapnúť READY state
            aktuálne slúži na vypínanie transition-delay, ktorá je v READY state neželaná*/

        setTimeout(function () {
            App.el.removeAttr('show').attr('ready', '');
            $('[component]').removeAttr('show').attr('ready', '');
            $('[page]').removeAttr('show').attr('ready', '');

            $('[state="show"]').attr('state', 'ready');
        }, 1100)
    },


    Video: {

        init: function () {
            // return;
            if ($('[id="home"] > video').length) return;

            console.log('video')

            let video = $('<video id="video" remove-on-save poster="' + WEB_ROOT + '/files/video-poster.jpg" playsinline muted loop></video>');
			let source = $('<source src="' + WEB_ROOT + '/files/video.mp4" type="video/mp4">');
            video.appendTo('[id="home"]');
            source.appendTo(video);
            video[0].play();
        },
    }
}

export default App;
